import { render, staticRenderFns } from "./artSpaceCom.vue?vue&type=template&id=9b8b166c&scoped=true"
import script from "./artSpaceCom.vue?vue&type=script&lang=js"
export * from "./artSpaceCom.vue?vue&type=script&lang=js"
import style0 from "./artSpaceCom.vue?vue&type=style&index=0&id=9b8b166c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8b166c",
  null
  
)

export default component.exports